import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Button, Card, Dropdown, Flex, theme, Typography } from "antd"
import { Header } from "antd/es/layout/layout"
import { UserOutlined } from "@ant-design/icons"

import image from "@src/app/assets/thank-you.svg"
import { authStore } from "@src/app/authStore"
import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import css from "@src/pages/statusConfirmation/index.module.css"

export const ThankYou = () => {
  const [delay, setDelay] = useState<number>(4)

  const { token } = theme.useToken()

  const navigate = useNavigate()

  const { logout, merchant } = authStore

  const redirect = () => {
    const { hostname } = window.location

    return router.navigate(
      hostname === "dashboard.sandbox.cryptix.io"
        ? paths.projects
        : paths.statusConfirmation,
    )
  }

  useEffect(() => {
    const id = setInterval(() => setDelay((d) => d - 1), 1000)

    return () => clearInterval(id)
  }, [])

  useEffect(() => {
    if (delay <= 0) {
      redirect()
    }
  }, [delay])

  return (
    <>
      <Header
        style={{
          alignItems: "center",
          background: token.colorBgLayout,
          display: "flex",
          justifyContent: "flex-end",
          textAlign: "right",
        }}
      >
        <div className={css.buttonsWrapper}>
          <Dropdown
            menu={{
              items: [
                {
                  key: "exit",
                  label: (
                    <a
                      onClick={() => logout().then(() => navigate(paths.auth))}
                    >
                      Exit
                    </a>
                  ),
                },
              ],
            }}
          >
            <Button
              icon={<UserOutlined />}
              id="GENERATED_ID_THANKYOU_BUTTON_VOID_1"
              size="large"
            >
              {merchant?.email}
            </Button>
          </Dropdown>
        </div>
      </Header>
      <Flex
        align="center"
        gap={32}
        style={{
          background: "white",
          borderRadius: 12,
          margin: "0 auto",
          marginTop: 100,
          padding: 24,
          width: "50%",
        }}
        vertical
      >
        <img alt="image" src={image} style={{ width: "200px" }} />

        <Flex align="center" gap={16} vertical>
          <Typography.Title level={4} style={{ margin: 0 }}>
            Thank you for reaching out to us.
          </Typography.Title>

          <Typography.Text>
            We have received your request and will contact you as soon as
            possible.
          </Typography.Text>

          <Typography.Title level={4} style={{ color: "#1C6C2A", margin: 0 }}>
            Redirect via {delay} s
          </Typography.Title>
        </Flex>
      </Flex>
    </>
  )
}
